import { render, staticRenderFns } from "./WorkExperiencePage.vue?vue&type=template&id=2f916b61&scoped=true&"
import script from "./WorkExperiencePage.vue?vue&type=script&lang=js&"
export * from "./WorkExperiencePage.vue?vue&type=script&lang=js&"
import style0 from "./WorkExperiencePage.vue?vue&type=style&index=0&id=2f916b61&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f916b61",
  null
  
)

export default component.exports